// extracted by mini-css-extract-plugin
export var base = "_2u-0";
export var updateBanner = "_2u-1";